export default __webpack_public_path__ + "static/media/strike-through.ee0c72a5.svg";